// extracted by mini-css-extract-plugin
export default {"hollow_dots_spinner":"style_hollow_dots_spinner__xfI7s","dot":"style_dot__CJjQz","hollow_dots_spinner-animation":"style_hollow_dots_spinner-animation__PIqpa"};